module.exports = __webpack_public_path__ + "img/342a5a81928b8dd25380a974abb468f4.png";